export const textColor = {
    color: '#262626'
};

export const cardStyle = {
    background: '#FFFFFF',
    border: '0px',
    borderRadius: '8px',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    fontWeight: 'normal',
    fontSize: '16px',
    padding: '40px',
    ...textColor
};

export const buttonStyle = {
    borderRadius: '4px',
    fontWeight: '600',
    fontSize: '14px'
};

export const leftButtonStyle = {
    borderRadius: '4px 0px 0px 4px',
    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
    fontWeight: '600',
    fontSize: '14px'
};

export const rightButtonStyle = {
    borderRadius: '0px 4px 4px 0px',
    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
    fontWeight: '600',
    fontSize: '14px'
};
export const defaultButtonStyle = {
    borderRadius: '4px',
    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
    fontWeight: '600',
    fontSize: '14px'
};

export const inputStyle = {
    borderRadius: '4px',
    width: '100%',
    lineHeight: '22px',
    marginBottom: '0px'
};

export const linkStyle = {
    fontWeight: '600'
};

export const bottomDisclaimerStyle = {
    textAlign: 'center',
    fontSize: '12px',
    marginBottom: '0px',
    width: '100%',
    justifyContent: 'center',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '20px',
    color: '#8C8C8C'
};
export const footerStyle = {
    fontSize: '12px',
    backgroundColor: '#F5F5F5',
    
    bottom: '0px',
    width: '100%',
    paddingTop: '10px',
    paddingBottom: '10px'
}

export const iconColor = {
    color: '#8C8C8C'
};

export const pageHeaderStyle = {
    padding: '40px 0px 24px',
    backgroundColor: '#F5F5F5',
    fontWeight: '600',
    fontSize: '30px',
    lineHeight: '38px',
    textAlign: 'left'
};

export const filterStyle = {
    border: '1px solid #BFBFBF',
    boxSizing: 'border-box',
    borderRadius: '4px',
    height: '40px',
    width: '100%',
    textAlign: 'left',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '22px',
    textColor: '#8C8C8C',
};

export const tableCardStyle = {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    borderRadius: '8px',
};

export const tableCardBodyStyle = {
    width: '100%',
    padding: '4px 4px 4px 4px',
};

export const tableTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#262626"
};

export const tableDescriptionStyle = {
    color: "#8C8C8C",
    fontSize: "14px"
};